import React from 'react';

const LeftArrow = () => (
  <svg
    width="12"
    height="21"
    viewBox="0 0 12 21"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    id="leftArrow"
  >
    <path
      d="M10.1126 0.450195L11.5 1.8935L3.27478 10.4502L11.5 19.0069L10.1126 20.4502L0.5 10.4502L10.1126 0.450195Z"
      fill="#323232"
    />
  </svg>
);

export default LeftArrow;
